import React  from 'react';

import MatchingProfileContent from "../content/MatchingProfileContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

function MatchingProfile() {
    return(
        <>
        <Navbar />
        <MatchingProfileContent/>
        <Footer />        
        </>
    );
}

export default MatchingProfile;